module.exports = __webpack_public_path__ + "img/vn.4bc2a560.svg";